import { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Icon from '@assets/images/Hero-Icone.png';
import {
  ContentWrapper,
  SectionContainer,
  ImageBox,
  FormContainer,
  SubmitButton,
  ErrorMessage,
  RecaptchaContainer,
} from './ContactOne.style';
import { useTranslation } from 'react-i18next';

function ContactOne() {
  const { t } = useTranslation('contact');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    tel: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [formMessage, setFormMessage] = useState(null);

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Nome é obrigatório';
    if (!formData.email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }

    if (!formData.tel.trim()) {
      newErrors.tel = 'Telefone é obrigatório';
    } else if (!/^\d{10,11}$/.test(formData.tel)) {
      newErrors.tel = 'Telefone inválido';
    }

    if (!formData.message.trim()) newErrors.message = 'Mensagem é obrigatória';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormMessage(null);

    if (!validate()) return;

    setIsSubmitting(true);

    try {
      const payload = {
        ...formData,
        access_key: import.meta.env.VITE_WEB3FORMS_ACCESS_KEY,
      };

      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.success) {
        setFormMessage({
          type: 'success',
          text: t('form.success'),
        });
        setFormData({ name: '', email: '', tel: '', message: '' });
        setRecaptchaValue(null);
      } else {
        setFormMessage({
          type: 'error',
          text: t('form.error'),
        });
      }
    } catch (err) {
      console.error(err);
      setFormMessage({ type: 'error', text: 'Erro ao enviar o formulário.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormValid =
    formData.name.trim() &&
    formData.email.trim() &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) &&
    formData.tel.trim() &&
    /^\d{10,11}$/.test(formData.tel) &&
    formData.message.trim() &&
    recaptchaValue;

  return (
    <SectionContainer>
      <ContentWrapper>
        <FormContainer>
          <form onSubmit={handleSubmit}>
            <h2>
              {t('contactOne.subtitle.spanBefore')}
              <span>2</span> {t('contactOne.subtitle.spanAfter')}
            </h2>

            <div>
              <label htmlFor="name">
                {t('form.label.name')} <span>*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder={t('form.placeholder')}
                value={formData.name}
                onChange={handleChange}
              />
              {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
            </div>

            <div>
              <label htmlFor="email">
                {t('form.label.email')} <span>*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder={t('form.placeholder')}
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <ErrorMessage>{errors.email}</ErrorMessage>}
            </div>

            <div>
              <label htmlFor="tel">
                {t('form.label.phone')} <span>*</span>
              </label>
              <input
                type="tel"
                name="tel"
                inputMode="numeric"
                placeholder={t('form.placeholder')}
                value={formData.tel}
                onChange={handleChange}
              />
              {errors.tel && <ErrorMessage>{errors.tel}</ErrorMessage>}
            </div>

            <div>
              <label htmlFor="message">
                {t('form.label.message')} <span>*</span>
              </label>
              <textarea
                name="message"
                placeholder={t('form.placeholder')}
                value={formData.message}
                onChange={handleChange}
              />
              {errors.message && <ErrorMessage>{errors.message}</ErrorMessage>}
            </div>

            <RecaptchaContainer>
              <ReCAPTCHA
                sitekey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                onChange={handleRecaptchaChange}
              />
            </RecaptchaContainer>

            <SubmitButton type="submit" disabled={!isFormValid || isSubmitting}>
              {isSubmitting ? 'Enviando...' : t('form.submit')}
            </SubmitButton>

            {formMessage && (
              <p
                style={{
                  marginTop: '1rem',
                  color: formMessage.type === 'success' ? 'green' : 'red',
                }}
              >
                {formMessage.text}
              </p>
            )}
          </form>
        </FormContainer>

        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
}

export default ContactOne;
